import React from "react"
import logoConnexia from "../images/outcomes.png"

const Footer = () => {
  return (
    <div>
      <footer>
        <div
          className="container"
          style={{ "padding-top": "20px", "padding-bottom": "20px" }}
        >
          <a className="navbar-brand-bottom" href="../index.html">
            <img src={logoConnexia} height={"44px"} alt="Connexia" />
          </a>
          <div style={{ float: "left", "margin-left": "10px" }}>
            <a
              className="footer-button"
              href="https://www.connexia.com/connexia-benefit"
              target="_blank"
              rel="noreferrer"
            >
              Connexia Societ&agrave; Benefit S.r.l. – share capital €
              500.000,00 I.V. – VAT, Tax and registration number: 12205240158
            </a>
            <a
              className="footer-button"
              href="https://www.connexia.com/privacy-policy-ita/"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            <a
              className="footer-button"
              href="../cookie.html"
              target="_blank"
              rel="noreferrer"
            >
              Cookie Policy
            </a>
          </div>
          <div style={{ clear: "both" }}></div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
